/* Hafız Mustafa 1864 — menü verisi. Fiyatları "price" alanına yazın (örn. "250 ₺"); boş bırakılırsa gösterilmez. */
window.HM_MENU = { sections: [
 {
  "id": "tabaklar",
  "title": {
   "tr": "Tabaklar",
   "en": "Platters",
   "es": "Bandejas",
   "zh": "拼盘"
  },
  "vign": "tail.png",
  "dishes": [
   {
    "name": {
     "tr": "Sultan Tabağı",
     "en": "Sultan Platter",
     "es": "Bandeja Sultán",
     "zh": "苏丹拼盘"
    },
    "price": "",
    "desc": {
     "tr": "Baklava çeşitlerinden paylaşımlık seçki.",
     "en": "A sharing selection of baklava varieties.",
     "es": "Selección variada de baklava para compartir.",
     "zh": "多款果仁蜜饼的分享拼盘。"
    },
    "img": "baklava-sultan-tabagi.jpg"
   },
   {
    "name": {
     "tr": "Saray Tabağı",
     "en": "Palace Platter",
     "es": "Bandeja Palacio",
     "zh": "皇宫拼盘"
    },
    "price": "",
    "img": "baklava-saray-tabagi.jpg"
   },
   {
    "name": {
     "tr": "Paşa Tabağı",
     "en": "Pasha Platter",
     "es": "Bandeja Bajá",
     "zh": "帕夏拼盘"
    },
    "price": "",
    "img": "baklava-pasa-tabagi.jpg"
   },
   {
    "name": {
     "tr": "Harem Tabağı",
     "en": "Harem Platter",
     "es": "Bandeja Harén",
     "zh": "后宫拼盘"
    },
    "price": "",
    "img": "baklava-harem-tabagi.jpg"
   },
   {
    "name": {
     "tr": "Dîvân Tabağı",
     "en": "Divan Platter",
     "es": "Bandeja Diván",
     "zh": "迪万拼盘"
    },
    "price": "",
    "img": "baklava-divan-tabagi.jpg"
   },
   {
    "name": {
     "tr": "Sadrâzam Tabağı",
     "en": "Grand Vizier Platter",
     "es": "Bandeja del Gran Visir",
     "zh": "大维齐尔拼盘"
    },
    "price": "",
    "img": "baklava-sadrazam-tabagi.jpg"
   },
   {
    "name": {
     "tr": "Yeniçeri Tabağı",
     "en": "Janissary Platter",
     "es": "Bandeja Jenízaro",
     "zh": "耶尼切里拼盘"
    },
    "price": "",
    "img": "baklava-yeniceri-tabagi.jpg"
   },
   {
    "name": {
     "tr": "Âfet-i Devrân",
     "en": "Âfet-i Devrân",
     "es": "Âfet-i Devrân",
     "zh": "Âfet-i Devrân"
    },
    "price": "",
    "desc": {
     "tr": "Kaymak ve fıstıkla, dönemin en beğenileni.",
     "en": "With clotted cream and pistachio; the favourite of its age.",
     "es": "Con nata cuajada y pistacho; el favorito de su época.",
     "zh": "以凝脂奶油和开心果制成，是当年最受欢迎的一款。"
    },
    "img": "baklava-afet-i-devran.jpg"
   }
  ],
  "note": {
   "tr": "* Tabaklarımız paylaşımlıktır; personelimiz size yardımcı olur.",
   "en": "* Our platters are for sharing; our staff will be glad to help.",
   "es": "* Nuestras bandejas son para compartir; nuestro personal estará encantado de ayudarle.",
   "zh": "* 我们的拼盘为分享装，工作人员将竭诚为您提供协助。"
  }
 },
 {
  "id": "baklava",
  "title": {
   "tr": "Baklavalar",
   "en": "Baklava",
   "es": "Baklava",
   "zh": "果仁蜜饼"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "Fıstıklı Baklava",
     "en": "Pistachio Baklava",
     "es": "Baklava de Pistacho",
     "zh": "开心果果仁蜜饼"
    },
    "price": "",
    "desc": {
     "tr": "Kat kat el açması yufka, Antep fıstığı ve sadeyağ; hafif şerbetli.",
     "en": "Layers of hand-rolled pastry with Antep pistachio and clarified butter; lightly syruped.",
     "es": "Capas de masa estirada a mano con pistacho de Antep y mantequilla clarificada; ligeramente almibarada.",
     "zh": "手工擀制的千层酥皮，选用安泰普开心果与黄油，糖浆清淡。"
    },
    "img": "baklava-fistikli-baklava.jpg"
   },
   {
    "name": {
     "tr": "Cevizli Baklava",
     "en": "Walnut Baklava",
     "es": "Baklava de Nuez",
     "zh": "核桃果仁蜜饼"
    },
    "price": "",
    "desc": {
     "tr": "Ceviz içiyle, klasik usul.",
     "en": "With walnut filling, the classic way.",
     "es": "Con relleno de nuez, al estilo clásico.",
     "zh": "核桃馅，经典做法。"
    },
    "img": "baklava-cevizli-baklava.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Kare Baklava",
     "en": "Square Pistachio Baklava",
     "es": "Baklava Cuadrada de Pistacho",
     "zh": "方形开心果果仁蜜饼"
    },
    "price": "",
    "desc": {
     "tr": "Bahçekapı’nın ilk gününden beri aynı kesim.",
     "en": "The same cut since the first day in Bahçekapı.",
     "es": "El mismo corte desde el primer día en Bahçekapı.",
     "zh": "自 Bahçekapı 首店开业以来，切法始终未变。"
    },
    "img": "baklava-fistikli-kare-baklava.jpg"
   },
   {
    "name": {
     "tr": "Cevizli Kare Baklava",
     "en": "Square Walnut Baklava",
     "es": "Baklava Cuadrada de Nuez",
     "zh": "方形核桃果仁蜜饼"
    },
    "price": "",
    "img": "baklava-cevizli-kare-baklava.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Pâdişah",
     "en": "Pistachio Padishah",
     "es": "Padishah de Pistacho",
     "zh": "开心果帕迪沙"
    },
    "price": "",
    "desc": {
     "tr": "Bol fıstıklı, kalın iç; saray usulü.",
     "en": "Generously filled with pistachio; palace style.",
     "es": "Generosamente relleno de pistacho; al estilo palaciego.",
     "zh": "开心果馅料丰盛，宫廷风味。"
    },
    "img": "baklava-fistikli-padisah.jpg"
   },
   {
    "name": {
     "tr": "Cevizli Pâdişah",
     "en": "Walnut Padishah",
     "es": "Padishah de Nuez",
     "zh": "核桃帕迪沙"
    },
    "price": "",
    "img": "baklava-cevizli-padisah.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Kuru Baklava",
     "en": "Dry Pistachio Baklava",
     "es": "Baklava Seca de Pistacho",
     "zh": "干式开心果果仁蜜饼"
    },
    "price": "",
    "desc": {
     "tr": "Az şerbetli, çıtır; uzun yola dayanıklı.",
     "en": "Less syrup, extra crisp; travels well.",
     "es": "Menos almíbar, más crujiente; ideal para llevar.",
     "zh": "糖浆较少，口感更脆，适合携带。"
    },
    "img": "baklava-fistikli-kuru-baklava.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Dürüm",
     "en": "Pistachio Roll",
     "es": "Rollo de Pistacho",
     "zh": "开心果卷"
    },
    "price": "",
    "desc": {
     "tr": "Fıstıkla sarılmış ince rulo.",
     "en": "A thin roll wrapped in pistachio.",
     "es": "Un fino rollo envuelto en pistacho.",
     "zh": "外裹开心果碎的细长酥卷。"
    },
    "img": "baklava-fistikli-durum.jpg"
   }
  ]
 },
 {
  "id": "baklava2",
  "title": {
   "tr": "Baklavalar II",
   "en": "Baklava II",
   "es": "Baklava II",
   "zh": "果仁蜜饼 II"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "Cevizli Dürüm",
     "en": "Walnut Roll",
     "es": "Rollo de Nuez",
     "zh": "核桃卷"
    },
    "price": "",
    "img": "baklava-cevizli-durum.jpg"
   },
   {
    "name": {
     "tr": "Havuç Dilimi",
     "en": "Carrot-Slice Baklava",
     "es": "Baklava Corte de Zanahoria",
     "zh": "胡萝卜形果仁蜜饼"
    },
    "price": "",
    "desc": {
     "tr": "Üçgen kesim, kalın fıstıklı iç.",
     "en": "Triangular cut with a thick pistachio filling.",
     "es": "Corte triangular con un relleno grueso de pistacho.",
     "zh": "三角形切块，开心果馅料厚实。"
    },
    "img": "baklava-havuc-dilimi.jpg"
   },
   {
    "name": {
     "tr": "Özel Şöbiyet",
     "en": "Special Şöbiyet",
     "es": "Şöbiyet Especial",
     "zh": "特制舒比耶特"
    },
    "price": "",
    "desc": {
     "tr": "Kaymaklı ve fıstıklı, yumuşak dokulu.",
     "en": "With clotted cream and pistachio; soft-textured.",
     "es": "Con nata cuajada y pistacho; textura suave.",
     "zh": "以凝脂奶油和开心果制成，口感软糯。"
    },
    "img": "baklava-ozel-sobiyet.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Ankara Dolma",
     "en": "Pistachio Ankara Dolma",
     "es": "Ankara Dolma de Pistacho",
     "zh": "开心果安卡拉多尔玛"
    },
    "price": "",
    "img": "baklava-fistikli-ankara-dolma.jpg"
   },
   {
    "name": {
     "tr": "Cevizli Ankara Dolma",
     "en": "Walnut Ankara Dolma",
     "es": "Ankara Dolma de Nuez",
     "zh": "核桃安卡拉多尔玛"
    },
    "price": "",
    "img": "baklava-cevizli-ankara-dolma.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Saray Sarma",
     "en": "Pistachio Palace Wrap",
     "es": "Envoltorio de Palacio con Pistacho",
     "zh": "开心果宫廷卷"
    },
    "price": "",
    "img": "baklava-fistikli-saray-sarma.jpg"
   },
   {
    "name": {
     "tr": "Cevizli Saray Sarma",
     "en": "Walnut Palace Wrap",
     "es": "Envoltorio de Palacio con Nuez",
     "zh": "核桃宫廷卷"
    },
    "price": "",
    "img": "baklava-cevizli-saray-sarma.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Sarı Burma",
     "en": "Pistachio Sarı Burma",
     "es": "Sari Burma de Pistacho",
     "zh": "开心果萨勒布尔玛"
    },
    "price": "",
    "desc": {
     "tr": "Burma yufka, yoğun fıstık.",
     "en": "Twisted pastry, dense pistachio.",
     "es": "Masa retorcida, pistacho denso.",
     "zh": "扭卷酥皮，开心果馅料浓密。"
    },
    "img": "baklava-fistikli-sari-burma.jpg"
   }
  ]
 },
 {
  "id": "baklava3",
  "title": {
   "tr": "Baklavalar III",
   "en": "Baklava III",
   "es": "Baklava III",
   "zh": "果仁蜜饼 III"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "Cevizli Sarı Burma",
     "en": "Walnut Sarı Burma",
     "es": "Sari Burma de Nuez",
     "zh": "核桃萨勒布尔玛"
    },
    "price": "",
    "img": "baklava-cevizli-sari-burma.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Kıvrım",
     "en": "Pistachio Kıvrım",
     "es": "Kivrim de Pistacho",
     "zh": "开心果克维鲁姆"
    },
    "price": "",
    "img": "baklava-fistikli-kivrim.jpg"
   },
   {
    "name": {
     "tr": "Cevizli Kıvrım",
     "en": "Walnut Kıvrım",
     "es": "Kivrim de Nuez",
     "zh": "核桃克维鲁姆"
    },
    "price": "",
    "img": "baklava-cevizli-kivrim.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Dilber",
     "en": "Pistachio Dilber",
     "es": "Dilber de Pistacho",
     "zh": "开心果迪尔贝尔"
    },
    "price": "",
    "img": "baklava-fistikli-dilber.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Cimcik",
     "en": "Pistachio Cimcik",
     "es": "Cimcik de Pistacho",
     "zh": "开心果吉姆吉克"
    },
    "price": "",
    "img": "baklava-fistikli-cimcik.jpg"
   },
   {
    "name": {
     "tr": "Cevizli Cimcik",
     "en": "Walnut Cimcik",
     "es": "Cimcik de Nuez",
     "zh": "核桃吉姆吉克"
    },
    "price": "",
    "img": "baklava-cevizli-cimcik.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Prenses",
     "en": "Pistachio Princess",
     "es": "Princesa de Pistacho",
     "zh": "开心果公主酥"
    },
    "price": "",
    "img": "baklava-fistikli-prenses.jpg"
   },
   {
    "name": {
     "tr": "Cevizli Prenses",
     "en": "Walnut Princess",
     "es": "Princesa de Nuez",
     "zh": "核桃公主酥"
    },
    "price": "",
    "img": "baklava-cevizli-prenses.jpg"
   }
  ]
 },
 {
  "id": "baklava4",
  "title": {
   "tr": "Baklavalar IV",
   "en": "Baklava IV",
   "es": "Baklava IV",
   "zh": "果仁蜜饼 IV"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "Fıstıklı Şehzâde",
     "en": "Pistachio Şehzade",
     "es": "Şehzade de Pistacho",
     "zh": "开心果谢赫扎德"
    },
    "price": "",
    "img": "baklava-fistikli-sehzade.jpg"
   },
   {
    "name": {
     "tr": "Cevizli Kelebek",
     "en": "Walnut Butterfly",
     "es": "Mariposa de Nuez",
     "zh": "核桃蝴蝶酥"
    },
    "price": "",
    "img": "baklava-cevizli-kelebek.jpg"
   },
   {
    "name": {
     "tr": "Cevizli Ev Baklavası",
     "en": "Home-style Walnut Baklava",
     "es": "Baklava de Nuez Casera",
     "zh": "家庭风味核桃果仁蜜饼"
    },
    "price": "",
    "img": "baklava-cevizli-ev-baklavasi.jpg"
   },
   {
    "name": {
     "tr": "Çikolatalı Fıstıklı Baklava",
     "en": "Chocolate Pistachio Baklava",
     "es": "Baklava de Chocolate y Pistacho",
     "zh": "巧克力开心果果仁蜜饼"
    },
    "price": "",
    "desc": {
     "tr": "Bitter çikolata ile.",
     "en": "With dark chocolate.",
     "es": "Con chocolate negro.",
     "zh": "以黑巧克力制成。"
    },
    "img": "baklava-cikolatali-fistikli-baklava.jpg"
   },
   {
    "name": {
     "tr": "Çikolatalı Cevizli Baklava",
     "en": "Chocolate Walnut Baklava",
     "es": "Baklava de Chocolate y Nuez",
     "zh": "巧克力核桃果仁蜜饼"
    },
    "price": "",
    "img": "baklava-cikolatali-cevizli-baklava.jpg"
   }
  ]
 },
 {
  "id": "kadayif",
  "title": {
   "tr": "Kadayıf & Fırın Tatlıları",
   "en": "Kadayıf & Baked Desserts",
   "es": "Kadayif & Postres al Horno",
   "zh": "卡达伊夫与烤制甜点"
  },
  "vign": "tail.png",
  "dishes": [
   {
    "name": {
     "tr": "Künefe",
     "en": "Künefe",
     "es": "Künefe",
     "zh": "库纳法"
    },
    "price": "",
    "desc": {
     "tr": "Tel kadayıf, peynir ve şerbet; sıcak servis.",
     "en": "Shredded pastry with cheese and syrup; served hot.",
     "es": "Masa deshilachada con queso y almíbar; se sirve caliente.",
     "zh": "丝状酥皮夹奶酪，浇糖浆，热食。"
    },
    "img": "kadayif-kunefe.jpg"
   },
   {
    "name": {
     "tr": "Çikolatalı Künefe",
     "en": "Chocolate Künefe",
     "es": "Künefe de Chocolate",
     "zh": "巧克力库纳法"
    },
    "price": "",
    "img": "kadayif-cikolatali-kunefe.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Kadayıf",
     "en": "Pistachio Kadayıf",
     "es": "Kadayif de Pistacho",
     "zh": "开心果卡达伊夫"
    },
    "price": "",
    "desc": {
     "tr": "Tel tel, sadeyağlı.",
     "en": "Shredded, with clarified butter.",
     "es": "Deshilachado, con mantequilla clarificada.",
     "zh": "丝状酥皮，配黄油。"
    },
    "img": "kadayif-fistikli-kadayif.jpg"
   },
   {
    "name": {
     "tr": "Ballı Kadayıf",
     "en": "Honey Kadayıf",
     "es": "Kadayif de Miel",
     "zh": "蜂蜜卡达伊夫"
    },
    "price": "",
    "img": "kadayif-balli-kadayif.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Halep",
     "en": "Pistachio Halep",
     "es": "Alepo de Pistacho",
     "zh": "开心果阿勒颇"
    },
    "price": "",
    "img": "kadayif-fistikli-halep.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Burma Kadayıf",
     "en": "Pistachio Burma Kadayıf",
     "es": "Kadayif Burma de Pistacho",
     "zh": "开心果布尔马卡达伊夫"
    },
    "price": "",
    "img": "kadayif-fistikli-burma-kadayif.jpg"
   },
   {
    "name": {
     "tr": "Sütlü Osmanlı Saray Kadayıfı",
     "en": "Ottoman Palace Kadayıf with Milk",
     "es": "Kadayif de Palacio Otomano con Leche",
     "zh": "牛奶奥斯曼宫廷卡达伊夫"
    },
    "price": "",
    "img": "kadayif-sutlu-osmanli-saray-kadayifi.jpg"
   }
  ]
 },
 {
  "id": "kadayif2",
  "title": {
   "tr": "Kadayıf & Fırın Tatlıları II",
   "en": "Kadayıf & Baked Desserts II",
   "es": "Kadayif & Postres al Horno II",
   "zh": "卡达伊夫与烤制甜点 II"
  },
  "vign": "tail.png",
  "dishes": [
   {
    "name": {
     "tr": "Fıstıklı Osmanlı Saray Kadayıfı",
     "en": "Ottoman Palace Kadayıf with Pistachio",
     "es": "Kadayif de Palacio Otomano con Pistacho",
     "zh": "开心果奥斯曼宫廷卡达伊夫"
    },
    "price": "",
    "img": "kadayif-fistikli-osmanli-saray-kadayifi.jpg"
   },
   {
    "name": {
     "tr": "Narlı Osmanlı Saray Kadayıfı",
     "en": "Ottoman Palace Kadayıf with Pomegranate",
     "es": "Kadayif de Palacio Otomano con Granada",
     "zh": "石榴奥斯曼宫廷卡达伊夫"
    },
    "price": "",
    "img": "kadayif-narli-osmanli-saray-kadayifi.jpg"
   },
   {
    "name": {
     "tr": "Ayva Tatlısı",
     "en": "Quince Dessert",
     "es": "Postre de Membrillo",
     "zh": "榅桲甜点"
    },
    "price": "",
    "desc": {
     "tr": "Kaymakla.",
     "en": "With clotted cream.",
     "es": "Con nata cuajada.",
     "zh": "配凝脂奶油。"
    },
    "img": "kadayif-ayva-tatlisi.jpg"
   },
   {
    "name": {
     "tr": "Kabak Tatlısı",
     "en": "Pumpkin Dessert",
     "es": "Postre de Calabaza",
     "zh": "南瓜甜点"
    },
    "price": "",
    "desc": {
     "tr": "Tahin ve cevizle.",
     "en": "With tahini and walnut.",
     "es": "Con tahini y nuez.",
     "zh": "配芝麻酱与核桃。"
    },
    "img": "kadayif-kabak-tatlisi.jpg"
   }
  ]
 },
 {
  "id": "sutlu",
  "title": {
   "tr": "Sütlü Tatlılar",
   "en": "Milk Desserts",
   "es": "Postres de Leche",
   "zh": "奶制甜点"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "Aşure",
     "en": "Ashure",
     "es": "Ashure",
     "zh": "阿舒雷"
    },
    "price": "",
    "desc": {
     "tr": "Noah’s pudding; buğday, baklagil ve kuru meyvelerle.",
     "en": "Noah’s pudding with wheat, pulses and dried fruit.",
     "es": "El pudín de Noé, con trigo, legumbres y frutos secos.",
     "zh": "诺亚布丁，以麦粒、豆类与果干制成。"
    }
   },
   {
    "name": {
     "tr": "Fırın Sütlaç",
     "en": "Baked Rice Pudding",
     "es": "Arroz con Leche al Horno",
     "zh": "烤米布丁"
    },
    "price": "",
    "desc": {
     "tr": "Üstü fırında kızarmış.",
     "en": "Oven-browned on top.",
     "es": "Dorado al horno por encima.",
     "zh": "表面经烤箱烘烤至焦香。"
    }
   },
   {
    "name": {
     "tr": "Tavuk Göğsü",
     "en": "Chicken Breast Pudding",
     "es": "Pudín de Pechuga de Pollo",
     "zh": "鸡胸布丁"
    },
    "price": "",
    "desc": {
     "tr": "Osmanlı saray mutfağından.",
     "en": "From the Ottoman palace kitchen.",
     "es": "De la cocina del palacio otomano.",
     "zh": "源自奥斯曼宫廷御膳房。"
    }
   },
   {
    "name": {
     "tr": "Fırın Tavuk Göğsü",
     "en": "Baked Chicken Breast Pudding",
     "es": "Pudín de Pechuga de Pollo al Horno",
     "zh": "烤鸡胸布丁"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Kazandibi",
     "en": "Kazandibi",
     "es": "Kazandibi",
     "zh": "卡赞迪比"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Keşkül-ü Fukara",
     "en": "Keşkül (Almond Pudding)",
     "es": "Keşkül (Pudín de Almendras)",
     "zh": "凯什库尔（杏仁布丁）"
    },
    "price": "",
    "desc": {
     "tr": "Badem sütlü.",
     "en": "With almond milk.",
     "es": "Con leche de almendra.",
     "zh": "以杏仁奶制成。"
    }
   },
   {
    "name": {
     "tr": "Güllaç",
     "en": "Güllaç",
     "es": "Güllaç",
     "zh": "居拉奇"
    },
    "price": "",
    "desc": {
     "tr": "Süt, gül suyu ve cevizle; ramazan tatlısı.",
     "en": "With milk, rose water and walnut; a Ramadan dessert.",
     "es": "Con leche, agua de rosas y nuez; postre de Ramadán.",
     "zh": "以牛奶、玫瑰水与核桃制成，为斋月甜点。"
    }
   },
   {
    "name": {
     "tr": "Zerde",
     "en": "Zerde (Saffron Rice Pudding)",
     "es": "Zerde (Pudín de Arroz con Azafrán)",
     "zh": "泽尔德（藏红花米布丁）"
    },
    "price": ""
   }
  ]
 },
 {
  "id": "sutlu2",
  "title": {
   "tr": "Sütlü Tatlılar II",
   "en": "Milk Desserts II",
   "es": "Postres de Leche II",
   "zh": "奶制甜点 II"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "Sütlü Zerde",
     "en": "Zerde with Milk",
     "es": "Zerde con Leche",
     "zh": "牛奶泽尔德"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Supangle",
     "en": "Supangle",
     "es": "Supangle",
     "zh": "苏潘格"
    },
    "price": "",
    "desc": {
     "tr": "Çikolatalı puding.",
     "en": "Chocolate pudding.",
     "es": "Pudín de chocolate.",
     "zh": "巧克力布丁。"
    },
    "img": "muhallebi-supangle.jpg"
   },
   {
    "name": {
     "tr": "Profiterol",
     "en": "Profiterole",
     "es": "Profiterol",
     "zh": "泡芙"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Damla Sakızlı Muhallebi",
     "en": "Gum Mastic Pudding",
     "es": "Pudín de Almáciga",
     "zh": "乳香脂布丁"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Fıstıklı Muhallebi",
     "en": "Pistachio Milk Pudding",
     "es": "Pudín de Leche con Pistacho",
     "zh": "开心果牛奶布丁"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Çilekli Muhallebi",
     "en": "Strawberry Milk Pudding",
     "es": "Pudín de Leche con Fresa",
     "zh": "草莓牛奶布丁"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Portakallı Muhallebi",
     "en": "Orange Milk Pudding",
     "es": "Pudín de Leche con Naranja",
     "zh": "橙子牛奶布丁"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Ayvalı Muhallebi",
     "en": "Quince Milk Pudding",
     "es": "Pudín de Leche con Membrillo",
     "zh": "榅桲牛奶布丁"
    },
    "price": ""
   }
  ]
 },
 {
  "id": "sutlu3",
  "title": {
   "tr": "Sütlü Tatlılar III",
   "en": "Milk Desserts III",
   "es": "Postres de Leche III",
   "zh": "奶制甜点 III"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "Kabaklı Muhallebi",
     "en": "Pumpkin Milk Pudding",
     "es": "Pudín de Leche con Calabaza",
     "zh": "南瓜牛奶布丁"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Kivili Muhallebi",
     "en": "Kiwi Milk Pudding",
     "es": "Pudín de Leche con Kiwi",
     "zh": "奇异果牛奶布丁"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "İncirli Muhallebi",
     "en": "Fig Pudding",
     "es": "Pudín de Higo",
     "zh": "无花果布丁"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Çikolatalı Çilekli Cup",
     "en": "Chocolate Strawberry Cup",
     "es": "Copa de Chocolate y Fresa",
     "zh": "巧克力草莓杯"
    },
    "price": "",
    "img": "muhallebi-cikolatali-cilekli-cup.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Çikolatalı Muhallebi",
     "en": "Pistachio Chocolate Pudding",
     "es": "Pudín de Chocolate con Pistacho",
     "zh": "开心果巧克力布丁"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Orman Meyveli Muhallebi",
     "en": "Forest Berry Pudding",
     "es": "Pudín de Frutos del Bosque",
     "zh": "森林莓果布丁"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Frambuazlı Muhallebi",
     "en": "Raspberry Pudding",
     "es": "Pudín de Frambuesa",
     "zh": "树莓布丁"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Meyveli Muhallebi",
     "en": "Fruit Pudding",
     "es": "Pudín de Frutas",
     "zh": "水果布丁"
    },
    "price": ""
   }
  ]
 },
 {
  "id": "sutlu4",
  "title": {
   "tr": "Sütlü Tatlılar IV",
   "en": "Milk Desserts IV",
   "es": "Postres de Leche IV",
   "zh": "奶制甜点 IV"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "Krem Karamel",
     "en": "Crème Caramel",
     "es": "Flan",
     "zh": "焦糖布丁"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Frambuazlı Trileçe",
     "en": "Raspberry Tres Leches",
     "es": "Tres Leches de Frambuesa",
     "zh": "树莓三奶蛋糕"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Karamelli Trileçe",
     "en": "Caramel Tres Leches",
     "es": "Tres Leches de Caramelo",
     "zh": "焦糖三奶蛋糕"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Safranlı Trileçe",
     "en": "Saffron Tres Leches",
     "es": "Tres Leches de Azafrán",
     "zh": "藏红花三奶蛋糕"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Kahveli Trileçe",
     "en": "Coffee Tres Leches",
     "es": "Tres Leches de Café",
     "zh": "咖啡三奶蛋糕"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Âlâ Trileçe",
     "en": "Âlâ Tres Leches",
     "es": "Tres Leches Âlâ",
     "zh": "阿拉三奶蛋糕"
    },
    "price": ""
   }
  ]
 },
 {
  "id": "pasta",
  "title": {
   "tr": "Pastalar",
   "en": "Cakes",
   "es": "Pasteles",
   "zh": "蛋糕"
  },
  "vign": "tail.png",
  "dishes": [
   {
    "name": {
     "tr": "Çikolatalı Fıstıklı Pasta",
     "en": "Chocolate Pistachio Cake",
     "es": "Pastel de Chocolate y Pistacho",
     "zh": "巧克力开心果蛋糕"
    },
    "price": "",
    "img": "pasta-cikolatali-fistikli-pasta.jpg"
   },
   {
    "name": {
     "tr": "Şefin Aşkı Çilekli Pasta",
     "en": "Chef’s Love Strawberry Cake",
     "es": "Pastel de Fresa Amor del Chef",
     "zh": "主厨之爱草莓蛋糕"
    },
    "price": "",
    "img": "pasta-sefin-aski-cilekli-pasta.jpg"
   },
   {
    "name": {
     "tr": "Şefin Aşkı Muzlu Pasta",
     "en": "Chef’s Love Banana Cake",
     "es": "Pastel de Plátano Amor del Chef",
     "zh": "主厨之爱香蕉蛋糕"
    },
    "price": "",
    "img": "pasta-sefin-aski-muzlu-pasta.jpg"
   },
   {
    "name": {
     "tr": "Çikolatalı Ganaj Pasta",
     "en": "Chocolate Ganache Cake",
     "es": "Pastel de Ganache de Chocolate",
     "zh": "巧克力甘纳许蛋糕"
    },
    "price": "",
    "img": "pasta-cikolatali-ganaj-pasta.jpg"
   },
   {
    "name": {
     "tr": "Çikolatalı Truff Pasta",
     "en": "Chocolate Truffle Cake",
     "es": "Pastel de Trufa de Chocolate",
     "zh": "巧克力松露蛋糕"
    },
    "price": "",
    "img": "pasta-cikolatali-truff-pasta.jpg"
   },
   {
    "name": {
     "tr": "Çikolatalı Sultan Pasta",
     "en": "Chocolate Sultan Cake",
     "es": "Pastel Sultán de Chocolate",
     "zh": "巧克力苏丹蛋糕"
    },
    "price": "",
    "img": "pasta-cikolatali-sultan-pasta.jpg"
   },
   {
    "name": {
     "tr": "Çikolatalı Krokanlı Pasta",
     "en": "Chocolate Croquant Cake",
     "es": "Pastel de Chocolate y Crocante",
     "zh": "巧克力脆果蛋糕"
    },
    "price": "",
    "img": "pasta-cikolatali-krokanli-pasta.jpg"
   }
  ]
 },
 {
  "id": "pasta2",
  "title": {
   "tr": "Pastalar II",
   "en": "Cakes II",
   "es": "Pasteles II",
   "zh": "蛋糕 II"
  },
  "vign": "tail.png",
  "dishes": [
   {
    "name": {
     "tr": "Frambuazlı Pasta",
     "en": "Raspberry Cake",
     "es": "Pastel de Frambuesa",
     "zh": "树莓蛋糕"
    },
    "price": "",
    "img": "pasta-frambuazli-pasta.jpg"
   },
   {
    "name": {
     "tr": "Frambuazlı Çikolatalı Pasta",
     "en": "Raspberry Chocolate Cake",
     "es": "Pastel de Frambuesa y Chocolate",
     "zh": "树莓巧克力蛋糕"
    },
    "price": "",
    "img": "pasta-frambuazli-cikolatali-pasta.jpg"
   },
   {
    "name": {
     "tr": "Çilekli Pasta",
     "en": "Strawberry Cake",
     "es": "Pastel de Fresa",
     "zh": "草莓蛋糕"
    },
    "price": "",
    "img": "pasta-cilekli-pasta.jpg"
   },
   {
    "name": {
     "tr": "Kakaolu Çilekli Pasta",
     "en": "Cocoa Strawberry Cake",
     "es": "Pastel de Cacao y Fresa",
     "zh": "可可草莓蛋糕"
    },
    "price": "",
    "img": "pasta-kakaolu-cilekli-pasta.jpg"
   },
   {
    "name": {
     "tr": "Orman Meyveli Pasta",
     "en": "Forest Berry Cake",
     "es": "Pastel de Frutos del Bosque",
     "zh": "森林莓果蛋糕"
    },
    "price": "",
    "img": "pasta-orman-meyveli-pasta.jpg"
   },
   {
    "name": {
     "tr": "Çikolatalı Orman Meyveli Pasta",
     "en": "Chocolate Forest Berry Cake",
     "es": "Pastel de Chocolate y Frutos del Bosque",
     "zh": "巧克力森林莓果蛋糕"
    },
    "price": "",
    "img": "pasta-cikolatali-orman-meyveli-pasta.jpg"
   },
   {
    "name": {
     "tr": "Meyveli Pasta",
     "en": "Fruit Cake",
     "es": "Pastel de Frutas",
     "zh": "水果蛋糕"
    },
    "price": "",
    "img": "pasta-meyveli-pasta.jpg"
   }
  ]
 },
 {
  "id": "pasta3",
  "title": {
   "tr": "Pastalar III",
   "en": "Cakes III",
   "es": "Pasteles III",
   "zh": "蛋糕 III"
  },
  "vign": "tail.png",
  "dishes": [
   {
    "name": {
     "tr": "Çikolatalı Meyveli Pasta",
     "en": "Chocolate Fruit Cake",
     "es": "Pastel de Chocolate y Frutas",
     "zh": "巧克力水果蛋糕"
    },
    "price": "",
    "img": "pasta-cikolatali-meyveli-pasta.jpg"
   },
   {
    "name": {
     "tr": "Çikolatalı Muzlu Pasta",
     "en": "Chocolate Banana Cake",
     "es": "Pastel de Chocolate y Plátano",
     "zh": "巧克力香蕉蛋糕"
    },
    "price": "",
    "img": "pasta-cikolatali-muzlu-pasta.jpg"
   },
   {
    "name": {
     "tr": "Profiterollü Pasta",
     "en": "Profiterole Cake",
     "es": "Pastel de Profiterol",
     "zh": "泡芙蛋糕"
    },
    "price": "",
    "img": "pasta-profiterollu-pasta.jpg"
   },
   {
    "name": {
     "tr": "Kabaklı Pasta",
     "en": "Pumpkin Cake",
     "es": "Pastel de Calabaza",
     "zh": "南瓜蛋糕"
    },
    "price": "",
    "img": "pasta-kabakli-pasta.jpg"
   },
   {
    "name": {
     "tr": "Fıstıklı Krokanlı Kaşık Pasta",
     "en": "Pistachio Croquant Spoon Cake",
     "es": "Pastel de Cuchara con Pistacho y Crocante",
     "zh": "开心果脆果勺子蛋糕"
    },
    "price": ""
   }
  ]
 },
 {
  "id": "lokum",
  "title": {
   "tr": "Lokumlar",
   "en": "Turkish Delight",
   "es": "Delicia Turca (Lokum)",
   "zh": "土耳其软糖"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "Çifte Kavrulmuş Lokum",
     "en": "Double-Roasted Turkish Delight",
     "es": "Delicia Turca Doblemente Tostada",
     "zh": "双重烘烤土耳其软糖"
    },
    "price": "",
    "desc": {
     "tr": "Bakır kazanda uzun kavrulur; 1864 reçetesi.",
     "en": "Slowly roasted in a copper cauldron; the 1864 recipe.",
     "es": "Tostada lentamente en un caldero de cobre; la receta de 1864.",
     "zh": "以铜锅长时间熬煮，沿用 1864 年的古法配方。"
    }
   },
   {
    "name": {
     "tr": "Sade Lokum",
     "en": "Plain Turkish Delight",
     "es": "Delicia Turca Clásica",
     "zh": "原味土耳其软糖"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Güllü Sade Lokum",
     "en": "Rose Turkish Delight",
     "es": "Delicia Turca de Rosa",
     "zh": "玫瑰土耳其软糖"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Naneli Sade Lokum",
     "en": "Mint Turkish Delight",
     "es": "Delicia Turca de Menta",
     "zh": "薄荷土耳其软糖"
    },
    "price": "",
    "img": "lokum-naneli-sade-lokum.jpg"
   },
   {
    "name": {
     "tr": "Limonlu Sade Lokum",
     "en": "Lemon Turkish Delight",
     "es": "Delicia Turca de Limón",
     "zh": "柠檬土耳其软糖"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Portakallı Sade Lokum",
     "en": "Orange Turkish Delight",
     "es": "Delicia Turca de Naranja",
     "zh": "橙子土耳其软糖"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Tarçınlı Sade Lokum",
     "en": "Cinnamon Turkish Delight",
     "es": "Delicia Turca de Canela",
     "zh": "肉桂土耳其软糖"
    },
    "price": ""
   },
   {
    "name": {
     "tr": "Damla Sakızlı Sade Lokum",
     "en": "Gum Mastic Turkish Delight",
     "es": "Delicia Turca de Almáciga",
     "zh": "乳香脂土耳其软糖"
    },
    "price": "",
    "img": "lokum-damla-sakizli-sade-lokum.jpg"
   }
  ]
 },
 {
  "id": "lokum2",
  "title": {
   "tr": "Lokumlar II",
   "en": "Turkish Delight II",
   "es": "Delicia Turca II",
   "zh": "土耳其软糖 II"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "Güllü Fıstıklı Lokum",
     "en": "Rose Pistachio Delight",
     "es": "Delicia de Rosa y Pistacho",
     "zh": "玫瑰开心果软糖"
    },
    "price": "",
    "img": "lokum-gullu-fistikli-lokum.jpg"
   },
   {
    "name": {
     "tr": "Sultan Duble Fıstıklı Lokum",
     "en": "Sultan Double Pistachio",
     "es": "Sultán Doble Pistacho",
     "zh": "苏丹双层开心果软糖"
    },
    "price": "",
    "img": "lokum-sultan-duble-fistikli-lokum.jpg"
   },
   {
    "name": {
     "tr": "Narlı Fıstıklı Duble Lokum",
     "en": "Pomegranate Pistachio Double",
     "es": "Doble de Granada y Pistacho",
     "zh": "石榴开心果双层软糖"
    },
    "price": "",
    "img": "lokum-narli-fistikli-duble-lokum.jpg"
   },
   {
    "name": {
     "tr": "Kivili Fıstıklı Duble Lokum",
     "en": "Kiwi Pistachio Double",
     "es": "Doble de Kiwi y Pistacho",
     "zh": "奇异果开心果双层软糖"
    },
    "price": "",
    "img": "lokum-kivili-fistikli-duble-lokum.jpg"
   },
   {
    "name": {
     "tr": "Portakallı Fındıklı Duble Lokum",
     "en": "Orange Hazelnut Double",
     "es": "Doble de Naranja y Avellana",
     "zh": "橙子榛果双层软糖"
    },
    "price": "",
    "img": "lokum-portakalli-findikli-duble-lokum.jpg"
   },
   {
    "name": {
     "tr": "Sütlü Çikolata Kaplı Fıstıklı Lokum",
     "en": "Milk Chocolate Pistachio Delight",
     "es": "Delicia de Pistacho con Chocolate con Leche",
     "zh": "牛奶巧克力开心果软糖"
    },
    "price": "",
    "img": "lokum-sutlu-cikolata-kapli-fistikli-lokum.jpg"
   },
   {
    "name": {
     "tr": "Bitter Çikolata Kaplı Narlı Fıstıklı Lokum",
     "en": "Dark Chocolate Pomegranate Pistachio Delight",
     "es": "Delicia de Granada y Pistacho con Chocolate Negro",
     "zh": "黑巧克力石榴开心果软糖"
    },
    "price": "",
    "img": "lokum-bitter-cikolata-kapli-narli-fistikli-lokum.jpg"
   },
   {
    "name": {
     "tr": "Kuş Lokumu",
     "en": "Kuş Lokumu",
     "es": "Kuş Lokumu",
     "zh": "库什洛库姆"
    },
    "price": ""
   }
  ]
 },
 {
  "id": "kahvalti",
  "title": {
   "tr": "Kahvaltı",
   "en": "Breakfast",
   "es": "Desayuno",
   "zh": "早餐"
  },
  "vign": "tail.png",
  "dishes": [
   {
    "name": {
     "tr": "Serpme Kahvaltı",
     "en": "Turkish Breakfast Spread",
     "es": "Desayuno Turco Completo",
     "zh": "土耳其式全套早餐"
    },
    "price": "",
    "desc": {
     "tr": "Peynirler, zeytin, reçeller, bal-kaymak, sıcak ekmek.",
     "en": "Cheeses, olives, preserves, honey and clotted cream, warm bread.",
     "es": "Quesos, aceitunas, mermeladas, miel con nata cuajada y pan caliente.",
     "zh": "奶酪、橄榄、果酱、蜂蜜配凝脂奶油，配热面包。"
    }
   },
   {
    "name": {
     "tr": "Su Böreği",
     "en": "Su Böreği (Layered Pastry)",
     "es": "Su Böreği (Masa en Capas)",
     "zh": "苏波雷（千层酥）"
    },
    "price": "",
    "desc": {
     "tr": "Beyaz peynirli, el açması.",
     "en": "Hand-rolled, with white cheese.",
     "es": "Elaborado a mano, con queso blanco.",
     "zh": "手工制作，内馅白奶酪。"
    },
    "img": "kahvalti-su-boregi.jpg"
   },
   {
    "name": {
     "tr": "Kaymak",
     "en": "Clotted Cream",
     "es": "Nata Cuajada (Kaymak)",
     "zh": "凝脂奶油"
    },
    "price": "",
    "desc": {
     "tr": "Bal ile.",
     "en": "With honey.",
     "es": "Con miel.",
     "zh": "配蜂蜜。"
    },
    "img": "kahvalti-kaymak.jpg"
   }
  ],
  "note": {
   "tr": "* Kahvaltı 08.00 – 12.00 arasında servis edilir.",
   "en": "* Breakfast is served between 08.00 and 12.00.",
   "es": "* El desayuno se sirve entre las 08.00 y las 12.00.",
   "zh": "* 早餐供应时间为 08:00 至 12:00。"
  }
 },
 {
  "id": "sicak",
  "title": {
   "tr": "Sıcak İçecekler",
   "en": "Hot Drinks",
   "es": "Bebidas Calientes",
   "zh": "热饮"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "Türk Kahvesi",
     "en": "Turkish Coffee",
     "es": "Café Turco",
     "zh": "土耳其咖啡"
    },
    "price": "",
    "desc": {
     "tr": "Bakır cezvede, közde.",
     "en": "In a copper pot, over embers.",
     "es": "En cezve de cobre, sobre brasas.",
     "zh": "以铜壶置于炭火上煮制。"
    },
    "img": "icecek-turk-kahvesi.jpg"
   },
   {
    "name": {
     "tr": "Duble Türk Kahvesi",
     "en": "Double Turkish Coffee",
     "es": "Café Turco Doble",
     "zh": "双份土耳其咖啡"
    },
    "price": "",
    "img": "icecek-duble-turk-kahvesi.jpg"
   },
   {
    "name": {
     "tr": "Damla Sakızlı Türk Kahvesi",
     "en": "Gum Mastic Turkish Coffee",
     "es": "Café Turco con Almáciga",
     "zh": "乳香脂土耳其咖啡"
    },
    "price": "",
    "img": "icecek-damla-sakizli-turk-kahvesi.jpg"
   },
   {
    "name": {
     "tr": "Duble Damla Sakızlı Kahve",
     "en": "Double Gum Mastic Coffee",
     "es": "Café Doble con Almáciga",
     "zh": "双份乳香脂咖啡"
    },
    "price": "",
    "img": "icecek-duble-damla-sakizli-kahve.jpg"
   },
   {
    "name": {
     "tr": "Espresso",
     "en": "Espresso",
     "es": "Espresso",
     "zh": "意式浓缩咖啡"
    },
    "price": "",
    "img": "icecek-espresso.jpg"
   },
   {
    "name": {
     "tr": "Duble Espresso",
     "en": "Double Espresso",
     "es": "Espresso Doble",
     "zh": "双份意式浓缩咖啡"
    },
    "price": "",
    "img": "icecek-duble-espresso.jpg"
   },
   {
    "name": {
     "tr": "Cappuccino",
     "en": "Cappuccino",
     "es": "Capuchino",
     "zh": "卡布奇诺"
    },
    "price": "",
    "img": "icecek-cappuccino.jpg"
   },
   {
    "name": {
     "tr": "Caffe Latte",
     "en": "Caffè Latte",
     "es": "Café con Leche",
     "zh": "拿铁咖啡"
    },
    "price": "",
    "img": "icecek-caffe-latte.jpg"
   },
   {
    "name": {
     "tr": "Filtre Kahve",
     "en": "Filter Coffee",
     "es": "Café de Filtro",
     "zh": "滤泡咖啡"
    },
    "price": "",
    "img": "icecek-filtre-kahve.jpg"
   },
   {
    "name": {
     "tr": "Sütlü Filtre",
     "en": "Filter Coffee with Milk",
     "es": "Café de Filtro con Leche",
     "zh": "牛奶滤泡咖啡"
    },
    "price": "",
    "img": "icecek-sutlu-filtre.jpg"
   }
  ]
 },
 {
  "id": "sicak2",
  "title": {
   "tr": "Sıcak İçecekler II",
   "en": "Hot Drinks II",
   "es": "Bebidas Calientes II",
   "zh": "热饮 II"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "Fincan Çay",
     "en": "Tea (cup)",
     "es": "Té (taza)",
     "zh": "红茶（茶杯装）"
    },
    "price": "",
    "img": "icecek-fincan-cay.jpg"
   },
   {
    "name": {
     "tr": "Bardak Çay",
     "en": "Tea (glass)",
     "es": "Té (vaso)",
     "zh": "红茶（玻璃杯装）"
    },
    "price": "",
    "img": "icecek-bardak-cay.jpg"
   },
   {
    "name": {
     "tr": "Sütlü Bardak Çay",
     "en": "Tea with Milk",
     "es": "Té con Leche",
     "zh": "奶茶"
    },
    "price": "",
    "img": "icecek-sutlu-bardak-cay.jpg"
   },
   {
    "name": {
     "tr": "Salep",
     "en": "Salep",
     "es": "Salep",
     "zh": "萨勒普"
    },
    "price": "",
    "desc": {
     "tr": "Tarçınlı; kış içeceği.",
     "en": "With cinnamon; a winter drink.",
     "es": "Con canela; bebida de invierno.",
     "zh": "配肉桂，为冬季饮品。"
    },
    "img": "icecek-salep.jpg"
   },
   {
    "name": {
     "tr": "Nane Çayı",
     "en": "Mint Tea",
     "es": "Té de Menta",
     "zh": "薄荷茶"
    },
    "price": "",
    "img": "icecek-nane-cayi.jpg"
   },
   {
    "name": {
     "tr": "Kış Çayı",
     "en": "Winter Tea",
     "es": "Té de Invierno",
     "zh": "冬季暖茶"
    },
    "price": "",
    "img": "icecek-kis-cayi.jpg"
   },
   {
    "name": {
     "tr": "Ihlamur",
     "en": "Linden Tea",
     "es": "Té de Tila",
     "zh": "菩提花茶"
    },
    "price": "",
    "img": "icecek-ihlamur.jpg"
   },
   {
    "name": {
     "tr": "Elma Çayı",
     "en": "Apple Tea",
     "es": "Té de Manzana",
     "zh": "苹果茶"
    },
    "price": "",
    "img": "icecek-elma-cayi.jpg"
   },
   {
    "name": {
     "tr": "Nar Çayı",
     "en": "Pomegranate Tea",
     "es": "Té de Granada",
     "zh": "石榴茶"
    },
    "price": "",
    "img": "icecek-nar-cayi.jpg"
   }
  ]
 },
 {
  "id": "soguk",
  "title": {
   "tr": "Soğuk İçecekler",
   "en": "Cold Drinks",
   "es": "Bebidas Frías",
   "zh": "冷饮"
  },
  "vign": "tail.png",
  "dishes": [
   {
    "name": {
     "tr": "Sıkma Portakal Suyu",
     "en": "Fresh Orange Juice",
     "es": "Zumo de Naranja Natural",
     "zh": "鲜榨橙汁"
    },
    "price": "",
    "img": "icecek-sikma-portakal-suyu.jpg"
   },
   {
    "name": {
     "tr": "Sıkma Nar Suyu",
     "en": "Fresh Pomegranate Juice",
     "es": "Zumo de Granada Natural",
     "zh": "鲜榨石榴汁"
    },
    "price": "",
    "img": "icecek-sikma-nar-suyu.jpg"
   },
   {
    "name": {
     "tr": "Üzüm Şırası",
     "en": "Grape Must",
     "es": "Mosto de Uva",
     "zh": "鲜榨葡萄汁"
    },
    "price": "",
    "img": "icecek-uzum-sirasi.jpg"
   },
   {
    "name": {
     "tr": "Limonata",
     "en": "Homemade Lemonade",
     "es": "Limonada Casera",
     "zh": "自制柠檬水"
    },
    "price": "",
    "img": "icecek-limonata.jpg"
   },
   {
    "name": {
     "tr": "Sade Soda",
     "en": "Mineral Water",
     "es": "Agua Mineral",
     "zh": "矿泉水"
    },
    "price": "",
    "img": "icecek-sade-soda.jpg"
   },
   {
    "name": {
     "tr": "Limonlu Soda",
     "en": "Mineral Water with Lemon",
     "es": "Agua Mineral con Limón",
     "zh": "柠檬矿泉水"
    },
    "price": "",
    "img": "icecek-limonlu-soda.jpg"
   },
   {
    "name": {
     "tr": "Süt",
     "en": "Milk",
     "es": "Leche",
     "zh": "牛奶"
    },
    "price": "",
    "img": "icecek-sut.jpg"
   },
   {
    "name": {
     "tr": "Su",
     "en": "Water",
     "es": "Agua",
     "zh": "水"
    },
    "price": "",
    "img": "icecek-su.jpg"
   }
  ]
 },
 {
  "id": "hediyelik",
  "title": {
   "tr": "Hediyelik",
   "en": "Gifts",
   "es": "Regalos",
   "zh": "礼品"
  },
  "vign": "bouquet.png",
  "dishes": [
   {
    "name": {
     "tr": "2'li Kahve Seti",
     "en": "Coffee Set for Two",
     "es": "Set de Café para Dos",
     "zh": "双人咖啡套装"
    },
    "price": "",
    "desc": {
     "tr": "Fincan, tabak ve Türk kahvesi.",
     "en": "Cups, saucers and Turkish coffee.",
     "es": "Tazas, platillos y café turco.",
     "zh": "咖啡杯、杯托与土耳其咖啡。"
    },
    "img": "hediyelik-2-li-kahve-seti.jpg"
   },
   {
    "name": {
     "tr": "2'li Çay Seti",
     "en": "Tea Set for Two",
     "es": "Set de Té para Dos",
     "zh": "双人茶具套装"
    },
    "price": "",
    "img": "hediyelik-2-li-cay-seti.jpg"
   },
   {
    "name": {
     "tr": "Sütlü-Bitterli Madlen",
     "en": "Milk & Dark Madeleines",
     "es": "Magdalenas de Chocolate con Leche y Negro",
     "zh": "牛奶与黑巧克力玛德琳"
    },
    "price": "",
    "img": "hediyelik-sutlu-bitterli-madlen.jpg"
   },
   {
    "name": {
     "tr": "Yeşil Çay - Elma Çayı - Nar Çayı",
     "en": "Green, Apple & Pomegranate Tea",
     "es": "Té Verde, de Manzana y de Granada",
     "zh": "绿茶、苹果茶与石榴茶"
    },
    "price": "",
    "img": "hediyelik-yesil-cay-elma-cayi-nar-cayi.jpg"
   }
  ],
  "note": {
   "tr": "* Hediyelik kutularımızın tamamı için online.hafizmustafa.com",
   "en": "* See online.hafizmustafa.com for our full range of gift boxes.",
   "es": "* Consulte online.hafizmustafa.com para ver toda nuestra gama de cajas de regalo.",
   "zh": "* 完整礼盒系列请见 online.hafizmustafa.com。"
  }
 }
] };
